var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchinline = function SvgSearchinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.333 2.666a4.667 4.667 0 1 0 0 9.334 4.667 4.667 0 0 0 0-9.334m-6 4.667a6 6 0 1 1 12 0 6 6 0 0 1-12 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.63 10.63c.26-.26.683-.26.943 0l2.9 2.9a.667.667 0 0 1-.943.943l-2.9-2.9a.667.667 0 0 1 0-.943",
    clipRule: "evenodd"
  })));
};
export default SvgSearchinline;